<template>
    <div class="score">
        您的完成題數：<span
            >{{ correctNum + incorrectNum }}/{{ totalQuestion }}</span
        >
        題
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState({
            correctNum: (state) => state.correctSet.length,
            incorrectNum: (state) => state.incorrectSet.length,
        }),
        ...mapGetters({
            getGameQuestionAmount: 'config/getGameQuestionAmount',
        }),
        totalQuestion() {
            const GAME = this.$route.params.type;
            return this.getGameQuestionAmount(GAME);
        },
    },
};
</script>

<style lang="scss" scoped>
.score {
    margin-top: 5px;
    font-size: 1.4em;
    text-align: center;
    span {
        font-size: 1.6em;
        color: #f09768;
    }
}
</style>
